/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { AbsenceCategory } from './AbsenceCategory';
import {
    AbsenceCategoryFromJSON,
    AbsenceCategoryFromJSONTyped,
    AbsenceCategoryToJSON,
    AbsenceCategoryToJSONTyped,
} from './AbsenceCategory';

/**
 * 
 * @export
 * @interface ListAbsenceCategoriesResponse
 */
export interface ListAbsenceCategoriesResponse {
    /**
     * 
     * @type {Array<AbsenceCategory>}
     * @memberof ListAbsenceCategoriesResponse
     */
    data: Array<AbsenceCategory>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListAbsenceCategoriesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListAbsenceCategoriesResponse interface.
 */
export function instanceOfListAbsenceCategoriesResponse(value: object): value is ListAbsenceCategoriesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListAbsenceCategoriesResponseFromJSON(json: any): ListAbsenceCategoriesResponse {
    return ListAbsenceCategoriesResponseFromJSONTyped(json, false);
}

export function ListAbsenceCategoriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAbsenceCategoriesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AbsenceCategoryFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListAbsenceCategoriesResponseToJSON(json: any): ListAbsenceCategoriesResponse {
      return ListAbsenceCategoriesResponseToJSONTyped(json, false);
  }

  export function ListAbsenceCategoriesResponseToJSONTyped(value?: ListAbsenceCategoriesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AbsenceCategoryToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

